/**
 * Resolve invited freelancer user ids for a brief from normalized Redux entities.
 *
 * @param {Record<string, unknown>|null|undefined} brief
 * @param {Record<string, { user?: unknown }>} inviteEntities
 * @returns {Set<string>}
 */
export function invitedFreelancerIdsForBrief(brief, inviteEntities) {
  const entities = inviteEntities || {};
  if (!brief || typeof brief !== 'object') {
    return new Set();
  }

  const raw = brief.invites;
  if (raw == null) {
    return new Set();
  }

  let list = [];
  if (Array.isArray(raw)) {
    list = raw;
  } else if (raw && Array.isArray(raw.invites)) {
    list = raw.invites;
  } else if (raw && raw.invites && Array.isArray(raw.invites.invites)) {
    list = raw.invites.invites;
  }

  const ids = new Set();
  for (const entry of list) {
    const invite =
      entry != null &&
      typeof entry === 'object' &&
      !Array.isArray(entry) &&
      entry.user != null
        ? entry
        : entities[entry] || entities[String(entry)];

    if (!invite || invite.user == null) {
      continue;
    }

    const u = invite.user;
    const uid = typeof u === 'object' && u != null && u.id != null ? u.id : u;
    if (uid != null && uid !== '') {
      ids.add(String(uid));
    }
  }

  return ids;
}

/**
 * @param {Record<string, unknown>|null|undefined} brief
 * @param {string|number|null|undefined} freelancerId
 * @param {Record<string, { user?: unknown }>} inviteEntities
 * @returns {boolean}
 */
export function isFreelancerInvitedToBrief(
  brief,
  freelancerId,
  inviteEntities
) {
  if (freelancerId == null || freelancerId === '') {
    return false;
  }
  return invitedFreelancerIdsForBrief(brief, inviteEntities).has(
    String(freelancerId)
  );
}
